import { ACTION_KINDS } from "../types/actions.js";
import { ALL_TILES } from "../tiles/index.js";
import { BUILDING_CONFIG } from "./buildings.js";
import { VIGOR_ZONES_CONFIG } from "./vigor_zones.js";
import { FORTRESS_CARDS_CONFIG } from "./fortress.js";
import { FORTRESS_CARDS_CATALOGUE_VERSION } from "../db/fortress_cards.js";
import { BOARD_TILES_CATALOGUE_VERSION } from "../db/board_tiles.js";
/** Bump when the GameConfig shape or default tables change incompatibly. */
export const CONFIG_VERSION = 0.5;
/** Snapshot the current code constants into a config — for NEW instances.
 * Catalogue version keys point at the seeded Mongo documents; the full
 * catalogues are filled from code defaults here and overwritten from DB when
 * persistence is available. */
export function defaultGameConfig() {
    return {
        startingProduction: 5,
        // Indexed by SEAT, which is turn position: seat 0 acts first and starts
        // one mineral short of the rest, and later seats ramp up (the last also
        // takes an extra obsidian) to offset acting later.
        startingResources: [
            [3, 2, 2, 2],
            [4, 2, 2, 2],
            [4, 2, 2, 2],
            [5, 2, 2, 2],
            [5, 2, 2, 2],
            [6, 2, 2, 2],
            [6, 2, 2, 2],
            [6, 2, 2, 3],
        ],
        actionsPerTurn: 2,
        lastPlayerTurns: 1,
        minPlayers: 2,
        maxPlayers: 8,
        actions: cloneData(ACTION_KINDS),
        fortressCardsVersion: FORTRESS_CARDS_CATALOGUE_VERSION,
        boardTilesVersion: BOARD_TILES_CATALOGUE_VERSION,
        fortressCards: cloneData(FORTRESS_CARDS_CONFIG),
        tiles: cloneData([...ALL_TILES]),
        vigorZones: cloneData(VIGOR_ZONES_CONFIG),
        buildings: cloneData(BUILDING_CONFIG),
    };
}
/** Deep copy of a plain JSON-safe value (the config tables are pure data), so
 * the snapshot never aliases the live constant objects. */
function cloneData(value) {
    return JSON.parse(JSON.stringify(value));
}
//# sourceMappingURL=game_config.js.map